/**
 * Utskick som publicerats utan granskning (planens 7B).
 *
 * **Inte en granskningskö.** Det som står här är redan ute, och texten ska säga
 * det. Rutan finns för att någon ska MÄRKA att något publicerats; borttagningen
 * görs i dokumentlistan, där raderingsknappen redan finns och redan kaskaderar
 * till chunkar, vektorer och fil.
 *
 * Rutan visas inte alls när den är tom — en permanent ruta blir tapet.
 */
export default function Published({ data }) {
  if (!data || data.published.length === 0) return null;

  return (
    <section className="card">
      <h2>Publicerat automatiskt</h2>
      <p className="hint">
        Utskick som gått ut till eleverna utan granskning de senaste{" "}
        {data.window_days} dagarna. Ta bort ett utskick under Dokument om det
        inte skulle ha publicerats.
      </p>
      <table>
        <thead>
          <tr>
            <th>Ämnesrad</th><th>Publicerat</th><th>Gäller till</th><th>Textstycken</th>
          </tr>
        </thead>
        <tbody>
          {data.published.map((post) => (
            <tr key={post.id}>
              <td>{post.title || post.subject}</td>
              <td>{new Date(post.published_at).toLocaleDateString("sv-SE")}</td>
              <td>{post.valid_until || "—"}</td>
              {/* Dokumentet kan vara raderat. Raden står kvar ändå — att dölja
                  den hade gjort listan till en lista över det som blev kvar. */}
              <td>{post.document_id ? post.chunks : "borttaget"}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </section>
  );
}
